import React, { useCallback, useEffect } from "react";
import "./AlertPip.scss";
import { Alert } from "@/models/Alerts";
import { useSelector } from "react-redux";
import { selectAlertsData } from "@/store/slices";
import { AlertUrgency } from "@/enums/Alerts";

export type AlertPipStyle = "dot" | "flag";

interface AlertPipProps {
  alertTypes: string[];
  hasAlerts?: (hasAlerts: boolean) => void;
  style?: AlertPipStyle;
}

const AlertPip: React.FC<AlertPipProps> = ({ alertTypes, hasAlerts, style }) => {
  const alertPipStyle = style || "dot";
  const { alerts = [] } = useSelector(selectAlertsData) || {};

  const getHighestPriorityCategory = useCallback(() => {
    const relevantAlerts = alerts.filter((alert: Alert) =>
      alertTypes.includes(alert.type)
    ) as Alert[];

    return {
      alerts: relevantAlerts,
      category:
        relevantAlerts.length === 0
          ? null
          : relevantAlerts.some(n => n.attentionLevel === AlertUrgency.Urgent)
            ? AlertUrgency.Urgent
            : relevantAlerts.some(n => n.attentionLevel === AlertUrgency.Rare)
              ? AlertUrgency.Rare
              : relevantAlerts.some(
                    n => n.attentionLevel === AlertUrgency.Common
                  )
                ? AlertUrgency.Common
                : null,
    };
  }, [alertTypes, alerts]);

  useEffect(() => {
    const { alerts: relevantAlerts } = getHighestPriorityCategory();
    hasAlerts?.(relevantAlerts.length > 0);
  }, [getHighestPriorityCategory, hasAlerts]);

  const { category } = getHighestPriorityCategory();

  if (!category) return null;

  const alertClass = `alert-pip ${category !== AlertUrgency.Common ? "urgent" : ""} ${alertPipStyle}`;
  return <div className={alertClass} />;
};

export default AlertPip;
